<script setup lang="ts">
import type { CmsElementPluebelCmsElementsHeadlineTextIconsRight } from "~/composables/useCustom";
import { useCmsElementConfig } from "#imports";

const props = defineProps<{
  content: CmsElementPluebelCmsElementsHeadlineTextIconsRight;
}>();

const { getConfigValue } = useCmsElementConfig(props.content);

const text = computed(() => getConfigValue("Text"));
const characteristicBox = computed(() => getConfigValue("characteristic_box"));
const headline = computed(() => getConfigValue("headline"));
const image = computed(() => getConfigValue("image"));
</script>
<template>
  <section class="pb-20 md:pb-28 lg:pb-40">
    <div class="container">
      <div class="max-w-[1110px] w-full m-auto overflow-hidden">
        <div class="flex flex-wrap gap-y-8 md:gap-y-10">
          <div class="w-full lg:w-[60%] xl:w-[68%] lg:pe-14 xl:pe-24">
            <h2 v-if="headline">{{ headline }}</h2>
            <div v-if="text" v-html="text"></div>
            <figure class="mt-10 lg:mt-14">
              <NuxtImg
                :src="image?.url"
                :alt="image?.alt || headline"
                loading="lazy"
                format="webp"
                :width="image?.metaData?.width"
                :height="image?.metaData?.height"
              />
            </figure>
          </div>
          <div
            class="w-full max-w-[420px] m-auto lg:w-[40%] xl:w-[32%] flex flex-col gap-4 md:gap-6 lg:gap-8 justify-end"
          >
            <template v-for="box in characteristicBox">
              <div class="text-center">
                <span class="inline-block mb-3 lg:mb-6 text-[0]">
                  <NuxtImg
                    loading="lazy"
                    format="webp"
                    :width="box.characteristic_icon?.metaData?.width"
                    :height="box.characteristic_icon?.metaData?.height"
                    :src="box.characteristic_icon?.url"
                    :alt="box.characteristic_headline"
                  />
                </span>
                <h5
                  v-if="box.characteristic_headline"
                  class="font-extrabold font-redit_sans_con text-xl md:text-2xl mb-4"
                >
                  {{ box.characteristic_headline }}
                </h5>
                <p class="text-lg">
                  {{ box.characteristic_text }}
                </p>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
